// START IMPORTS
import { Box, styled } from '@ltvco/refresh-lib/theme';
// END IMPORTS

export const ReportListItemRoot = styled(Box, {
  shouldForwardProp: (prop) => prop !== 'clickable',
})<{ clickable?: boolean }>(({ theme, clickable }) => ({
  backgroundColor: theme.palette.background.paper,
  border: `1px solid ${theme.palette.divider}`,
  borderRadius: Math.max(Number(theme.shape.borderRadius) || 4, 8),
  padding: theme.spacing(2),
  boxShadow: 'none',
  ...(clickable ? { cursor: 'pointer' } : {}),
}));

/** Text `Button`s in `trailing` slots — shared sx for both placements. */
export const trailingTextButtonSlotSx = {
  '& .MuiButton-text': {
    color: 'primary.main',
    fontWeight: 600,
    textTransform: 'none' as const,
    minWidth: 'auto',
    px: 1,
  },
};
